<template>
	<div class="width-100 height-100 overflow-y-auto pt-5 px-6">
		<h1 class="reg">Ideas</h1>
		<h3 class="reg mt-4 mb-2">Team ideas ({{ filteredAccountIdeasWithoutArchived.length }})</h3>
		<AddNewIdea class="my-4" />
		<template>
			<InspirationCenterMenuItem
				class="mb-4"
				:key="idea.id"
				:ideaId="idea.id"
				v-for="idea in filteredAccountIdeasWithoutArchived"
				@item-clicked="() => openIdeaDialog(idea.id)"
			/>
			<h3 class="reg mt-4">More Ideas</h3>
		</template>
		<InspirationCenterTabs class="divider pb-2" :selectedTabs.sync="selectedTabs" />
		<InspirationCenterMenuItem
			class="mb-4"
			:key="idea.id"
			:ideaId="idea.id"
			v-for="idea in currentIdeasWithoutTeamIdeas"
			@item-clicked="() => openIdeaDialog(idea.id)"
		/>
		<h3 v-if="currentIdeasWithoutTeamIdeas.length === 0 && !isLoading" class="reg flex-centerize">No results</h3>
		<div v-intersect="endIntersect">
			<AppLoader class="py-4" v-if="isLoading" />
		</div>
	</div>
</template>

<script>
import InspirationCenterTabs from './InspirationCenterTabs.vue';
import InspirationCenterMenuItem from './InspirationCenterMenuItem.vue';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { getInspirationIdeas, getMyTeamIdeas } from '@/store/modules/inspirationCenter/actions.js';
import { useInspirationIdeas, useMyTeamsIdeas, useIdea } from '@/store/modules/inspirationCenter/getters.js';
import InspirationCenterService from '@/components/InspirationCenter/inspiration-center-service.js';
import { ALL_TAG_NAME, PUBLIC_TYPE } from '@/components/InspirationCenter/inspiration-center.const.js';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import AddNewIdea from './AddNewIdea.vue';
import { getAllDirectoryApps } from '@/store/modules/apps/actions';
export default {
	name: 'InspirationCenterMenuContent',
	components: { InspirationCenterTabs, InspirationCenterMenuItem, AddNewIdea },
	computed: {
		...mapGettersShorthand({ useInspirationIdeas, useMyTeamsIdeas, useIdea }),
		isAllMode() {
			return this.selectedTabs.includes(ALL_TAG_NAME);
		},
		filteredAccountIdeasWithoutArchived() {
			return this.useMyTeamsIdeas
				.filter((idea) => !InspirationCenterService.isIdeaArchived(idea))
				.sort((a, b) => {
					const aCreatedAt = new Date(a.account_idea.created_at);
					const bCreatedAt = new Date(b.account_idea.created_at);
					if (aCreatedAt < bCreatedAt) {
						return 1;
					}
					if (aCreatedAt > bCreatedAt) {
						return -1;
					}
					return 0;
				});
		},
		currentIdeasWithoutTeamIdeas() {
			return this.currentIdeasIds
				.map((id) => this.useIdea(id))
				.filter((idea) => !this.filteredAccountIdeasWithoutArchived.some((teamIdea) => teamIdea.id === idea.id))
				.filter((idea) => !InspirationCenterService.isIdeaArchived(idea));
		},
	},
	methods: {
		...mapActionsShorthand({ getInspirationIdeas, getMyTeamIdeas, getAllDirectoryApps }),
		openIdeaDialog(id) {
			AppDialogManagerService.openIdeaDialog({ ideaId: id });
		},
		async fetchIdeas(appendResults = true) {
			if (this.hasNextPage) {
				this.isLoading = true;
				try {
					const res = await this.getInspirationIdeas({
						page: this.page,
						type: PUBLIC_TYPE,
						tags: this.isAllMode ? null : this.selectedTabs,
					});
					this.hasNextPage = Boolean(res.next);
					if (appendResults) {
						this.currentIdeasIds = [...this.currentIdeasIds, ...res.results.map(({ id }) => id)];
					} else {
						this.currentIdeasIds = res.results.map(({ id }) => id);
					}
					this.page++;
				} catch {
					this.$toast.error('Something went wrong, please try again later');
				} finally {
					this.isLoading = false;
				}
			}
		},
		endIntersect(entries, observer, isIntersecting) {
			if (isIntersecting) {
				this.onScrollToBottom();
			}
		},
		onScrollToBottom() {
			if (!this.isLoading) {
				this.fetchIdeas();
			}
		},
		resetPagination() {
			this.page = 1;
			this.currentIdeasIds = [];
			this.hasNextPage = true;
		},
	},
	data() {
		return {
			page: 1,
			isLoading: false,
			hasNextPage: true,
			currentIdeasIds: [],
			selectedTabs: [ALL_TAG_NAME],
		};
	},
	created() {
		this.getMyTeamIdeas();
		this.getAllDirectoryApps({ page: 1 });
	},
	watch: {
		selectedTabs: {
			handler() {
				this.resetPagination();
				this.fetchIdeas(false);
			},
			immediate: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.tab-button {
	cursor: pointer;
	&.selected {
		text-decoration: underline;
	}
}
.divider {
	border-bottom: 1px solid #e5e5e5;
}
</style>
